import ScrollPin from "./scroll/scroll-pin";
import {isMobile} from "../common/globalVars";
import {MathUtil} from "../utils/MathUtil";

export default class MotionOeraStoryScrollSvg extends ScrollPin{
    constructor(triggerEl, targetEl, svgEl, toggleTxtEls, lineBottomEl ,maxDashOffset, isCenter) {
        super(triggerEl,targetEl, isCenter);
        this.maxDashOffset = maxDashOffset;
        this.svgEl = svgEl;
        this.toggleTxtEls = toggleTxtEls;
        this.lineBottomEl = lineBottomEl;

        // console.log(this.lineBottomEl);
        this.svgEl.style.strokeMiterlimit = maxDashOffset;
        this.svgEl.style.strokeDashoffset = maxDashOffset;
    }

    onScrollHandler(e) {
        super.onScrollHandler(e);
    }

    onCustomScrollHandler(velocity, maxVelocity) {
        super.onCustomScrollHandler(velocity, maxVelocity);

        let targetDashOffset = MathUtil.map(velocity, 0, maxVelocity, this.maxDashOffset, 0);
        if (targetDashOffset) {
            this.svgEl.style.strokeDashoffset = targetDashOffset;
        }

        let currentTxt = Math.round(MathUtil.clamp(velocity/maxVelocity, 0,1 )*3);
        this.setTxt(currentTxt);
    }

    setTxt(currentTxt) {
        if (!this.toggleTxtEls) return;

        this.toggleTxtEls.forEach((el)=>{
                el.classList.remove('onShow');
            }
        )
        // console.log(currentTxt);
        if (this.toggleTxtEls[currentTxt]) this.toggleTxtEls[currentTxt].classList.add('onShow');
        if (currentTxt > 2) {
            this.lineBottomEl.classList.add('onTrans');
        } else {
            this.lineBottomEl.classList.remove('onTrans');
        }
    }

    onResizeHandler() {
        //@include calc-prop-set('width', 70%, 120%);
        let ratio;
        if(this.svgEl) {
            if (isMobile(window.innerWidth)) {
                ratio = 1.1;
            } else {
                ratio = 0.7;
            }
            this.svgEl.parentNode.style.width = window.innerWidth * ratio +'px';
            this.svgEl.parentNode.style.height = window.innerWidth * ratio +'px';
            // console.log(this.svgEl);
        }
        super.onResizeHandler();
    }
}
